/**
 * Epoch milliseconds for an API timestamp string or a `Date`.
 *
 * Compare timestamps through this, never as strings: `<` on two ISO strings
 * compares text, and the API's `…+00:00` and `toISOString()`'s `….000Z` differ
 * for the same instant.
 */
export const toMs = (value: string | Date): number => new Date(value).getTime();

/** Whether a `[start, end)` timestamp range overlaps the window `[from, to)`. */
export const overlapsRange = (
  range: { start: string | Date; end: string | Date },
  from: Date,
  to: Date,
): boolean =>
  toMs(range.start) < to.getTime() && toMs(range.end) > from.getTime();
